import React, { FC } from 'react';

import { useSelector } from 'store';

import { IDynamicUiField } from 'plugins/api/types';

import 'plugins/theme/components/EditPanel/EditPanel.scss';

// typ danych wejściowych
interface IProps {
  field: IDynamicUiField;
  pageSymbol: string;
  componentSymbol: string;
}

const DynamicTile: FC<IProps> = ({ field, pageSymbol, componentSymbol }) => {
  // pobieranie globalnego stanu kontekstu danych
  const { contextData } = useSelector((state) => state.dynamicPage);

  return (
    <div className="dynamicTile">
      <div>{field.label}</div>
      <div>{contextData?.[pageSymbol]?.[componentSymbol]?.[field.field_symbol]}</div>
    </div>
  );
};

export default DynamicTile;
